/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistanceTreeNode
 */
export interface DistanceTreeNode {
    /**
     * 
     * @type {number}
     * @memberof DistanceTreeNode
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DistanceTreeNode
     */
    distance?: number;
    /**
     * 
     * @type {DistanceTreeNode}
     * @memberof DistanceTreeNode
     */
    left?: DistanceTreeNode;
    /**
     * 
     * @type {DistanceTreeNode}
     * @memberof DistanceTreeNode
     */
    right?: DistanceTreeNode;
}

/**
 * Check if a given object implements the DistanceTreeNode interface.
 */
export function instanceOfDistanceTreeNode(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DistanceTreeNodeFromJSON(json: any): DistanceTreeNode {
    return DistanceTreeNodeFromJSONTyped(json, false);
}

export function DistanceTreeNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistanceTreeNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
        'left': !exists(json, 'left') ? undefined : DistanceTreeNodeFromJSON(json['left']),
        'right': !exists(json, 'right') ? undefined : DistanceTreeNodeFromJSON(json['right']),
    };
}

export function DistanceTreeNodeToJSON(value?: DistanceTreeNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'distance': value.distance,
        'left': DistanceTreeNodeToJSON(value.left),
        'right': DistanceTreeNodeToJSON(value.right),
    };
}

